<button
	mat-icon-button
	class="close-button"
	aria-label="Close"
	(click)="closeCallback.emit()"
>
	<mat-icon svgIcon="close" />
</button>
